import { render, staticRenderFns } from "./VoidTillSlip.template.vue?vue&type=template&id=4a83c8fb&scoped=true&"
var script = {}
import style0 from "./VoidTillSlip.template.vue?vue&type=style&index=0&id=4a83c8fb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a83c8fb",
  null
  
)

export default component.exports